import { render, staticRenderFns } from "./Ratecards.vue?vue&type=template&id=4b399d45&"
import script from "./Ratecards.vue?vue&type=script&lang=js&"
export * from "./Ratecards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports